export default __webpack_public_path__ + "static/media/login_prize.3165c2ce.png";